import { useEffect } from 'react';
import { useStoreFields } from '@atlassian/jira-software-backlog/src/common/hooks/use-store-fields/main.tsx';
import { REFRESH_SOURCE_GLOBAL_ISSUE_CREATE } from '../../model/constants';
import type { GlobalIssueCreateProps } from '../../model/types';
import { useBacklogDispatch, useBacklogSelector } from '../../state';
import { refreshDataRequest } from '../../state/actions/app';
import { issueParentsSelector } from '../../state/selectors/issue-parent';

type Props = {
	// eslint-disable-next-line jira/react/handler-naming
	bindToOnJiraGlobalIssueCreateClose: (
		arg1: (event: Event, issues: GlobalIssueCreateProps[]) => void,
	) => void;
};

const GICOnCloseHandler = ({ bindToOnJiraGlobalIssueCreateClose }: Props) => {
	const dispatch = useBacklogDispatch();
	const issueParents = useBacklogSelector((state) => issueParentsSelector(state));
	const storeFieldsActions = useStoreFields({
		issueParents,
	});

	useEffect(() => {
		bindToOnJiraGlobalIssueCreateClose((_, issues) => {
			dispatch(refreshDataRequest(REFRESH_SOURCE_GLOBAL_ISSUE_CREATE, issues, storeFieldsActions));
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return null;
};

export default GICOnCloseHandler;
